import { IOutlinedButtonProps } from "./module/constants";
import { FaSyncAlt, FaPen, FaRegWindowClose } from "react-icons/fa";

// Style
import classes from "./OutlinedButton.module.scss";

const OutlinedButton = (props: IOutlinedButtonProps) => {
  const {
    isFilterButton,
    isORWBButton,
    ORWBActivated,
    onClick,
    disabled,
    children,
    type,
    fullColored,
    refreshIcon = false,
    editIcon = false,
    closeIcon = false,
  } = props;
  const classname = () => {
    if (disabled) return classes.disabled;
    if (isFilterButton)
      return fullColored
        ? classes["filterButton_colored"]
        : classes.filterButton;
    if (isORWBButton) {
      if (ORWBActivated) {
        return classes["button_coloredORWBactivated"];
      } else {
        return fullColored
          ? classes["button_coloredORWB"]
          : classes["button_ORWB"];
      }
    }
    return fullColored ? classes["button_colored"] : classes.button;
  };
  return (
    <button
      className={`${classname()}`}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {refreshIcon ? <FaSyncAlt /> : null}
      {editIcon ? <FaPen /> : null}
      {closeIcon ? (
        <>
          <FaRegWindowClose style={{ fontSize: "1rem" }} />{" "}
        </>
      ) : null}
      {refreshIcon || editIcon ? " " : null}
      {children}
    </button>
  );
};

export default OutlinedButton;
